import { createTheme } from '@mui/material/styles';
import { palette } from './palette';

/**
 * MUI module augmentations for our custom palette members live in a dedicated,
 * side-effect-only module. Imported here so the augmented types are part of the
 * program wherever the theme is used.
 */
import './augmentations.types';

export const theme = createTheme({
  components: {
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: '#939393',
          '&.Mui-completed': {
            color: '#14A5B2',
          },
          '&.Mui-active': {
            color: '#14A5B2',
          },
        },
        active: {},
        completed: {},
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          height: '32px',
          lineHeight: 1,
          textTransform: 'capitalize',
        },
        outlined: {
          backgroundColor: palette.white,
        },
        outlinedPrimary: {
          borderColor: palette.primary.main,
          '&:hover': {
            backgroundColor: palette.primary.main,
            color: palette.white,
          },
        },
      },
    },
  },
  typography: {
    fontFamily: '"Lato", sans-serif',
  },
  palette: {
    darkaccent: '#20547B',
    darkaccentLight: '#4c7695',

    ...palette,
  },
});
